import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
    Box,
    Button,
    Grid,
} from "@mui/material";

import {
    t,
    Trans
} from "@lingui/macro";

import {
    SegregationFormProps,
    SegregationFormState
} from "./models";

import { withUseFormHook, } from "@sinossi/mates-react-library";
import * as Yup from "yup";
import { ZPlayFormField, ZPlaySelect } from "commons/fields";

import {
    CURRENCY_CONSTANT,
    SEGREGATION_TYPE_FORM_CONSTANT,
    SegregationType
} from "commons/form-constants";

const SegregationFormSchema = Yup.object().shape({
    segregationType: Yup.string().required(t({
        id: "sf-segregation-type-required-msg",
        message: "Indicare un tipo di segregazione"
    }))
});

class SegregationForm extends React.Component<SegregationFormProps & UseFormReturn, SegregationFormState> {
    private submitForm = (values: any) => {

        let segregationFormStepData: any = {};

        segregationFormStepData.segregationType = values.segregationType;

        if (segregationFormStepData.segregationType === SegregationType.PAY_PER_VIEW) {
            segregationFormStepData.price = values.price;
            segregationFormStepData.currency = values.currency;
        }

        this.props.onSegregationSubmit(segregationFormStepData)
    };

    render() {
        return (<Box>
            <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                <Grid container
                    p={3}
                    borderRadius="5px"
                    bgcolor={process.env.REACT_APP_THIRD_COLOR}>

                    <Grid item xs={12} md={4}>
                        <ZPlaySelect
                            name="segregationType"
                            defaultValue={process.env.REACT_APP_DEFAULT_CONTENT_UPLOAD_SEGREGATION || null}
                            label={t({
                                id: "sf-segregation-type",
                                message: "Tipo di segregazione"
                            })}
                            required={true}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                            disabled={this.props.readOnly}>
                            {SEGREGATION_TYPE_FORM_CONSTANT.map(
                                (item, index) => (<option value={item.key} key={item.key}>{item.label}</option>))}
                        </ZPlaySelect>
                    </Grid>

                    {this.props.getValues("segregationType") === SegregationType.PAY_PER_VIEW &&
                        <Grid container columnSpacing={3} mt={2}>
                            <Grid item xs={12} sm={6} md={6}>
                                <ZPlayFormField
                                    label={t({
                                        id: "sf-price",
                                        message: "Prezzo"
                                    })}
                                    name="price"
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <ZPlaySelect
                                    label={t({
                                        id: "sf-currency",
                                        message: "Valuta"
                                    })}
                                    name="currency"
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}>
                                    {CURRENCY_CONSTANT.map(
                                        (item, index) => (<option value={item.key} key={item.key}>{item.label}</option>))}
                                </ZPlaySelect>
                            </Grid>
                            {this.props.hasAvailabilityDays && <Grid item xs={12} sm={6} md={6}>
                                <ZPlayFormField
                                    label={t({
                                        id: "sf-availability-days",
                                        message: "Giorni di disponibilità noleggio"
                                    })}
                                    name="availabilityDays"
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>}
                        </Grid>}
                </Grid>
                <Grid item
                    xs={12}
                    mt={2}
                    textAlign={"right"}>
                    <Button
                        variant="outlined"
                        color={"primary"}
                        onClick={() => this.props.onSegregationBack()}
                        sx={{
                            marginRight: "10px",
                        }}
                    >
                        <Trans id="sf-back-button">Indietro</Trans>
                    </Button>
                    <Button
                        variant="contained"
                        color={"primary"}
                        disabled={this.props.formState.isSubmitting}
                        type="submit"
                    >
                        <Trans id="sf-submit-button">Avanti</Trans>
                    </Button>
                </Grid>
            </form>
        </Box>);
    }

}

export default withUseFormHook<{}>(SegregationForm, SegregationFormSchema, {});
